module.exports = __webpack_public_path__ + "static/img/background.ec3a4a22.svg";